  function insertarContenidoPackPrimerosDias() {
    // Solo insertar si no existe ya
    if (document.getElementById('pimun-pack-content')) return;
    var info = document.querySelector('h1');
    if (!info) return;
    var contentDiv = document.createElement('div');
    contentDiv.id = 'pimun-pack-content';
    contentDiv.textContent = 'Incluye Enterito + Gorro + Manta swaddle';
    // Estilo: igual al de bienvenida, gris legible, responsivo
    contentDiv.style = [
      'font-family: "Montserrat", "Arial", sans-serif',
      'font-size: 0.92rem',
      'font-weight: 400',
      'color: #7a7a7a',
      'margin-bottom: 7px',
      'letter-spacing: 0.01em',
      'line-height: 1.1',
      'white-space: nowrap',
      'overflow: hidden',
      'text-overflow: ellipsis',
      'max-width: 100%',
      'display: block'
    ].join(';') + ';';
    var styleTag = document.createElement('style');
    styleTag.textContent =
      '@media (max-width: 749px) {' +
      '  #pimun-pack-content {' +
      '    font-size: 0.78rem !important;' +
      '    margin-bottom: 5px !important;' +
      '  }' +
      '}';
    document.head.appendChild(styleTag);
    info.parentNode.insertBefore(contentDiv, info);
  }
/* ============================================
  PIMÚN — PACKS SIN ETIQUETA DE PROMO
   Precio en Shopify = precio CON descuento.
   El script oculta el precio original del tema y muestra:
     - Precio "antes" tachado
     - Precio real grande

   No crea ni muestra etiqueta de promoción.
   ============================================ */

(function () {
  'use strict';

  /* Configuración de descuentos por producto.
     factor = 1 / (1 - descuento). Ej: 20% → 1/0.80 = 1.25, 15% → 1/0.85 ≈ 1.1765 */
  var PRODUCTOS = [
    { keywords: ['bienvenida', 'pack-bienvenida'], factor: 1.25, pct: 20 },
    { keywords: ['primeros-dias', 'primeros dias', 'primeros días', 'primeros'], factor: 1.17647, pct: 15 },
    { keywords: ['sueno', 'sueño', 'set-sueno', 'set-sueño'], factor: 1.42857, pct: 30 },
    { keywords: ['paseo', 'set-paseo'], factor: 1.25, pct: 20 }
  ];
    function insertarContenidoPackPaseo() {
      // Solo insertar si no existe ya
      if (document.getElementById('pimun-pack-content')) return;
      var info = document.querySelector('h1');
      if (!info) return;
      var contentDiv = document.createElement('div');
      contentDiv.id = 'pimun-pack-content';
      contentDiv.textContent = 'Incluye Set paseo + Gabucha + Gorro';
      contentDiv.style = [
        'font-family: "Montserrat", "Arial", sans-serif',
        'font-size: 0.92rem',
        'font-weight: 400',
        'color: #7a7a7a',
        'margin-bottom: 7px',
        'letter-spacing: 0.01em',
        'line-height: 1.1',
        'white-space: nowrap',
        'overflow: hidden',
        'text-overflow: ellipsis',
        'max-width: 100%',
        'display: block'
      ].join(';') + ';';
      var styleTag = document.createElement('style');
      styleTag.textContent =
        '@media (max-width: 749px) {' +
        '  #pimun-pack-content {' +
        '    font-size: 0.78rem !important;' +
        '    margin-bottom: 5px !important;' +
        '  }' +
        '}';
      document.head.appendChild(styleTag);
      info.parentNode.insertBefore(contentDiv, info);
    }
    function insertarContenidoPackSueno() {
      // Solo insertar si no existe ya
      if (document.getElementById('pimun-pack-content')) return;
      var info = document.querySelector('h1');
      if (!info) return;
      var contentDiv = document.createElement('div');
      contentDiv.id = 'pimun-pack-content';
      contentDiv.textContent = 'Incluye Pijama convertible + Mitones + Manta swaddle';
      // Estilo: igual al de bienvenida, gris legible, responsivo
      contentDiv.style = [
        'font-family: "Montserrat", "Arial", sans-serif',
        'font-size: 0.92rem',
        'font-weight: 400',
        'color: #7a7a7a',
        'margin-bottom: 7px',
        'letter-spacing: 0.01em',
        'line-height: 1.1',
        'white-space: nowrap',
        'overflow: hidden',
        'text-overflow: ellipsis',
        'max-width: 100%',
        'display: block'
      ].join(';') + ';';
      var styleTag = document.createElement('style');
      styleTag.textContent =
        '@media (max-width: 749px) {' +
        '  #pimun-pack-content {' +
        '    font-size: 0.78rem !important;' +
        '    margin-bottom: 5px !important;' +
        '  }' +
        '}';
      document.head.appendChild(styleTag);
      info.parentNode.insertBefore(contentDiv, info);
    }
  var DEFAULT_FACTOR = 1.25;
  var DEFAULT_PCT = 20;
  var _initDone = false;
  var _observerCreated = false;
  var _priceTimer = null;
  var _imageTimer = null;

  inyectarEstilosPacks();

  /* ── DETECCIÓN ── */

  function obtenerConfigProducto() {
    var url = window.location.pathname.toLowerCase();
    if (url.indexOf('/products/') === -1) return null;

    // Buscar por URL
    for (var i = 0; i < PRODUCTOS.length; i++) {
      for (var k = 0; k < PRODUCTOS[i].keywords.length; k++) {
        if (url.indexOf(PRODUCTOS[i].keywords[k]) !== -1) return PRODUCTOS[i];
      }
    }

    // Buscar por título H1
    var titulo = document.querySelector('h1');
    if (titulo) {
      var h1 = titulo.textContent.toLowerCase();
      for (var i = 0; i < PRODUCTOS.length; i++) {
        for (var k = 0; k < PRODUCTOS[i].keywords.length; k++) {
          if (h1.indexOf(PRODUCTOS[i].keywords[k]) !== -1) return PRODUCTOS[i];
        }
      }
    }

    // Fallback genérico: URL con pack/regalo/set
    if (url.indexOf('pack') !== -1 || url.indexOf('regalo') !== -1 || url.indexOf('set') !== -1) {
      return { factor: DEFAULT_FACTOR, pct: DEFAULT_PCT, keywords: [] };
    }

    return null;
  }

  function esProductoPack() {
    return obtenerConfigProducto() !== null;
  }

  /* ── UTILIDADES ── */

  function parsearPrecio(texto) {
    var limpio = texto.replace(/[^0-9]/g, '');
    return limpio ? parseInt(limpio, 10) : NaN;
  }

  function formatearPrecio(num) {
    return '$' + Math.round(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function inyectarEstilosPacks() {
    if (document.getElementById('pimun-bw-inline-styles')) return;

    var style = document.createElement('style');
    style.id = 'pimun-bw-inline-styles';
    style.textContent = [
      'html.pimun-bw-pending product-price [ref="priceContainer"] { opacity: 0 !important; }',
      'html.pimun-bw-ready product-price [ref="priceContainer"] { opacity: 1; transition: opacity 0.12s ease; }'
    ].join('\n');
    document.head.appendChild(style);
  }

  function marcarPrecioComoPendiente() {
    document.documentElement.classList.add('pimun-bw-pending');
    document.documentElement.classList.remove('pimun-bw-ready');
  }

  function marcarPrecioComoListo() {
    document.documentElement.classList.remove('pimun-bw-pending');
    document.documentElement.classList.add('pimun-bw-ready');
  }

  function limpiarBloquesPacks() {
    document.querySelectorAll('.pimun-bw-wrapper').forEach(function (el) {
      el.remove();
    });
  }

  function obtenerContenedorPrecio(precioEl) {
    return precioEl.closest('[ref="priceContainer"]') || precioEl.parentNode;
  }

  /* ── DESCUENTO ── */

  function aplicarDescuento() {
    var config = obtenerConfigProducto();
    if (!config) return;

    var precioEl = document.querySelector('product-price .price');
    if (!precioEl) return;

    var precioConDescuento = parsearPrecio(precioEl.textContent);
    if (isNaN(precioConDescuento) || precioConDescuento <= 0) return;

    var precioOriginal = Math.round(precioConDescuento * config.factor);
    var contenedor = obtenerContenedorPrecio(precioEl);
    var existente = contenedor.querySelector('.pimun-bw-wrapper');

    if (existente) {
      var originalExistente = existente.querySelector('.pimun-bw-original');
      var saleExistente = existente.querySelector('.pimun-bw-sale-price');
      if (originalExistente) originalExistente.textContent = formatearPrecio(precioOriginal);
      if (saleExistente) saleExistente.textContent = formatearPrecio(precioConDescuento);

      precioEl.style.display = 'none';
      marcarPrecioComoListo();
      return;
    }

    precioEl.style.display = 'none';

    var wrapper = document.createElement('div');
    wrapper.className = 'pimun-bw-wrapper';

    var originalEl = document.createElement('span');
    originalEl.className = 'pimun-bw-original';
    originalEl.textContent = formatearPrecio(precioOriginal);
    originalEl.style.cssText = 'text-decoration:line-through;color:#aaa;opacity:1;font-size:0.88rem;font-weight:400;display:block;margin-top:2px;';
    wrapper.appendChild(originalEl);

    var saleEl = document.createElement('span');
    saleEl.className = 'pimun-bw-sale-price';
    saleEl.textContent = formatearPrecio(precioConDescuento);
    saleEl.style.cssText = 'color:#1E2A3A;font-weight:700;font-size:1.4rem;display:block;margin-top:2px;letter-spacing:-0.02em;';
    wrapper.appendChild(saleEl);

    contenedor.appendChild(wrapper);
    marcarPrecioComoListo();
  }

  function refrescarDescuento() {
    marcarPrecioComoPendiente();
    limpiarBloquesPacks();

    var precioEl = document.querySelector('product-price .price');
    if (!precioEl) return;

    precioEl.style.display = '';
    aplicarDescuento();
  }

  /* ── CAMBIO DE IMAGEN ── */

  // Estrategia: buscar la miniatura cuyo <img> contenga un keyword
  // que coincida con la opción elegida. Sin índices fijos ni JSON.

  function obtenerThumbnails() {
    // Probar múltiples selectores del tema
    var selectores = [
      'slideshow-controls button',
      'slideshow-controls .slideshow-control button',
      '.slideshow-controls__thumbnails button',
      '.thumbnail-list__item button',
      '.product__media-list .product__media-item'
    ];

    for (var s = 0; s < selectores.length; s++) {
      var els = document.querySelectorAll(selectores[s]);
      if (els.length > 1) {
        return Array.prototype.slice.call(els);
      }
    }

    // Último recurso: cualquier botón dentro de slideshow-controls
    var fallback = document.querySelectorAll('slideshow-controls [role="button"], slideshow-controls button, slideshow-controls a');
    return Array.prototype.slice.call(fallback);
  }

  function buscarThumbnailPorKeyword(keyword) {
    var thumbs = obtenerThumbnails();
    var kw = keyword.toLowerCase();

    for (var i = 0; i < thumbs.length; i++) {
      var imgs = thumbs[i].querySelectorAll('img');
      if (imgs.length === 0) {
        // El botón mismo podría ser un img o tener background
        var parent = thumbs[i].closest('[class*="slideshow"], [class*="thumbnail"]');
        if (parent) imgs = parent.querySelectorAll('img');
      }

      for (var j = 0; j < imgs.length; j++) {
        var src = (imgs[j].currentSrc || imgs[j].getAttribute('src') || imgs[j].srcset || '').toLowerCase();
        if (src.indexOf(kw) !== -1) {
          return thumbs[i];
        }
      }
    }

    return null;
  }

  function clickearMiniatura(btn) {
    if (!btn) return;

    // Forzar el foco y el click inmediato
    btn.focus();
    btn.click();

    // Disparar eventos manualmente para máxima compatibilidad
    var evt = document.createEvent('MouseEvents');
    evt.initEvent('mousedown', true, true);
    btn.dispatchEvent(evt);
    evt = document.createEvent('MouseEvents');
    evt.initEvent('mouseup', true, true);
    btn.dispatchEvent(evt);
    evt = document.createEvent('MouseEvents');
    evt.initEvent('pointerdown', true, true);
    btn.dispatchEvent(evt);
    evt = document.createEvent('MouseEvents');
    evt.initEvent('pointerup', true, true);
    btn.dispatchEvent(evt);
    // No hacer doble click ni retardo
  }

  function keywordsParaOpcion(grupoTexto, opcionTexto) {
    var grupo = (grupoTexto || '').toLowerCase();
    var opcion = (opcionTexto || '').toLowerCase();

    // SET PRIMEROS DÍAS — mapeo explícito
    if (grupo.includes('enterito')) {
      if (opcion.includes('picueta') && opcion.includes('beige')) {
        return ['enterito-bebe-algodon-pima-manga-larga-blanco'];
      }
      if (opcion.includes('detalle') && opcion.includes('rosa')) {
        return ['enterito-bebe-suave-y-comodo-blanco-ribete-rosa-manga-larga'];
      }
    }
    if (grupo.includes('gorro')) {
      if (opcion.includes('bordado') && opcion.includes('ovejita')) {
        return ['gorro-bebe-algodon-pima-suave-con-bordado-de-oveja-899'];
      }
      if (opcion.includes('vuelos') && opcion.includes('rosa')) {
        return ['gorro-bebe-algodon-pima-suave-y-comodo-128'];
      }
    }
    if (grupo.includes('manta')) {
      if (opcion.includes('picueta') && opcion.includes('beige')) {
        return ['manta-suave-doble-para-bebe-blanca-lana-bordado-oveja'];
      }
      if (opcion.includes('borde') && opcion.includes('algodon') && opcion.includes('rosa')) {
        return ['manta-doble-bebe-algodon-pima-manta-blanca-borde-rosa'];
      }
      if (opcion.includes('rosa')) {
        return ['manta-doble-bebe-algodon-pima-manta-blanca-borde-rosa'];
      }
    }

    // SET SUEÑO — mapeo explícito
    if (grupo.includes('convertible')) {
      if ((opcion.includes('rn') || opcion.includes('0-3')) && opcion.includes('mes')) {
        return ['bebe-ropon-convertible-bebe-blanco-liso-estampado-oveja-luna'];
      }
    }
    if (grupo.includes('manta') && opcion.includes('picueta') && opcion.includes('beige')) {
      return ['manta-suave-doble-para-bebe-blanca-lana-bordado-oveja'];
    }
    if (grupo.includes('manta') && opcion.includes('borde') && opcion.includes('algodon') && opcion.includes('rosa')) {
      return ['manta-doble-bebe-algodon-pima-manta-blanca-borde-rosa'];
    }

    // SET BIENVENIDA — mapeo explícito
    if (grupo.includes('enterito') || grupo.includes('talla')) {
      return ['enterito-bebe-algodon-pima-manga-larga-blanco'];
    }
    // Gabucha
    if (grupo.includes('gabucha')) {
      if (opcion.includes('camel')) return ['gabuchas-corduroy-camel-5'];
      if (opcion.includes('rosa')) return ['gabuchas-corduroy-algodon-palo-rosa-1'];
      if (opcion.includes('beige')) return ['gabuchas-corduroy-algodon-beige-1'];
      return ['gabucha'];
    }
    // Manta (Bienvenida)
    if (grupo.includes('manta')) {
      if (opcion.includes('rosa')) return ['manta-doble-bebe-algodon-pima-manta-blanca-borde-rosa'];
      if (opcion.includes('picueta') || opcion.includes('beige')) return ['manta-suave-doble-para-bebe-blanca-lana-bordado-oveja'];
      return ['manta'];
    }

    // Fallback genérico
    return [];
  }

  function sincronizarImagen(grupoTexto, opcionTexto) {
    if (_imageTimer) clearTimeout(_imageTimer);

    var keywords = keywordsParaOpcion(grupoTexto, opcionTexto);
    if (keywords.length === 0) return;

    var galeria = document.querySelector('.product__media-list, .slideshow, .product-gallery, .product__media, .product-gallery__media-list');
    var mainImg = galeria ? galeria.querySelector('img') : null;
    var lastSrc = mainImg ? mainImg.currentSrc || mainImg.src : null;

    // Oculta la imagen principal mientras se realiza el cambio
    if (mainImg) {
      mainImg.style.display = 'none';
    }
    if (galeria) {
      galeria.style.visibility = 'visible';
    }

    var intentos = 0;
    var maxIntentos = 10;
    var observer = null;

    function mostrarMainImgSiCorresponde() {
      if (!mainImg) return;
      observer = new MutationObserver(function() {
        var newSrc = mainImg.currentSrc || mainImg.src;
        // Si la imagen principal cambió y ahora corresponde a la variante, mostrarla
        var corresponde = false;
        for (var k = 0; k < keywords.length; k++) {
          if (newSrc && newSrc.indexOf(keywords[k]) !== -1) {
            corresponde = true;
            break;
          }
        }
        if (corresponde) {
          mainImg.style.display = '';
          if (observer) observer.disconnect();
        } else {
          mainImg.style.display = 'none';
        }
      });
      observer.observe(mainImg, { attributes: true, attributeFilter: ['src'] });
    }

    function intentarCambio() {
      var btn = null;
      for (var k = 0; k < keywords.length; k++) {
        btn = buscarThumbnailPorKeyword(keywords[k]);
        if (btn) break;
      }
      if (btn) {
        clickearMiniatura(btn);
      }
      intentos++;
      if (intentos < maxIntentos) {
        setTimeout(intentarCambio, 120);
      }
    }

    mostrarMainImgSiCorresponde();
    _imageTimer = setTimeout(intentarCambio, 120);
  }

  /* ── ESCUCHAR VARIANTES ── */

  function escucharVariantes() {
    var labels = document.querySelectorAll('.variant-option__button-label');

    labels.forEach(function (label) {
      if (label.dataset.pimunListener === '1') return;
      label.dataset.pimunListener = '1';

      label.addEventListener('click', function () {
        var fieldset = label.closest('fieldset');
        var legend = fieldset ? fieldset.querySelector('legend') : null;
        var grupoTexto = legend ? legend.textContent : '';
        var labelTexto = label.querySelector('.variant-option__button-label__text');
        var opcionTexto = labelTexto ? labelTexto.textContent : label.textContent;

        // Reaplicar precio después del re-render del tema.
        if (_priceTimer) clearTimeout(_priceTimer);
        _priceTimer = setTimeout(function () {
          refrescarDescuento();
        }, 450);

        // Sincronizar imagen buscando la miniatura por keyword.
        sincronizarImagen(grupoTexto, opcionTexto);
      });
    });
  }

  /* ── OBSERVAR RERENDERS DEL TEMA ── */

  function observarVariantes() {
    if (_observerCreated) return;
    _observerCreated = true;

    var target = document.querySelector('product-info') || document.querySelector('main') || document.body;
    if (!target) return;

    var timer = null;
    var observer = new MutationObserver(function () {
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () {
        escucharVariantes();
        refrescarDescuento();
      }, 600);
    });

    observer.observe(target, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true
    });
  }

  /* ── COLECCIÓN PACKS Y REGALOS ── */

  function esColeccionPacks() {
    var url = window.location.pathname.toLowerCase();
    // Detectar cualquier colección que tenga "pack" o "regalo" en la URL
    if (url.indexOf('/collections/') === -1) return false;
    return url.indexOf('pack') !== -1 || url.indexOf('regalo') !== -1;
  }

  function obtenerConfigTarjeta(productPrice) {
    // Buscar el enlace del producto más cercano para determinar el descuento
    var card = productPrice.closest('a[href*="/products/"]') || productPrice.closest('[class*="card"]');
    var href = '';
    if (card) {
      var link = card.tagName === 'A' ? card : card.querySelector('a[href*="/products/"]');
      if (link) href = link.getAttribute('href').toLowerCase();
    }
    // Buscar título del card
    var titulo = '';
    if (card) {
      var tituloEl = card.querySelector('h3, h2, .card__heading, [class*="title"]');
      if (tituloEl) titulo = tituloEl.textContent.toLowerCase();
    }

    for (var i = 0; i < PRODUCTOS.length; i++) {
      for (var k = 0; k < PRODUCTOS[i].keywords.length; k++) {
        if (href.indexOf(PRODUCTOS[i].keywords[k]) !== -1) return PRODUCTOS[i];
        if (titulo.indexOf(PRODUCTOS[i].keywords[k]) !== -1) return PRODUCTOS[i];
      }
    }
    // Fallback: descuento por defecto
    return { factor: DEFAULT_FACTOR, pct: DEFAULT_PCT, keywords: [] };
  }

  function aplicarDescuentoEnTarjetas() {
    // Buscar TODOS los product-price con precio visible en la página
    var allPrices = document.querySelectorAll('product-price');

    for (var i = 0; i < allPrices.length; i++) {
      var productPrice = allPrices[i];
      if (productPrice.dataset.pimunBwCard === '1') continue;

      // Ignorar si ya está dentro del product-info (página de producto embebida)
      if (productPrice.closest('product-info')) continue;

      var precioEl = productPrice.querySelector('.price');
      if (!precioEl) continue;

      var texto = precioEl.textContent.trim();
      if (!texto) continue;

      var precioConDescuento = parsearPrecio(texto);
      if (isNaN(precioConDescuento) || precioConDescuento <= 0) continue;

      productPrice.dataset.pimunBwCard = '1';

      var config = obtenerConfigTarjeta(productPrice);
      var precioOriginal = Math.round(precioConDescuento * config.factor);

      // Ocultar el product-price original
      productPrice.style.display = 'none';

      // Crear bloque de precios
      var wrapper = document.createElement('div');
      wrapper.className = 'pimun-bw-card-wrapper';

      var pricesLine = document.createElement('div');
      pricesLine.className = 'pimun-bw-card-prices';

      var originalSpan = document.createElement('span');
      originalSpan.className = 'pimun-bw-card-original';
      originalSpan.textContent = formatearPrecio(precioOriginal);
      pricesLine.appendChild(originalSpan);

      var saleSpan = document.createElement('span');
      saleSpan.className = 'pimun-bw-card-sale';
      saleSpan.textContent = formatearPrecio(precioConDescuento);
      pricesLine.appendChild(saleSpan);

      wrapper.appendChild(pricesLine);

      // Insertar justo después del product-price
      productPrice.parentNode.insertBefore(wrapper, productPrice.nextSibling);
    }
  }

  function initColeccion() {
    if (!esColeccionPacks()) return;

    // Intentar aplicar de inmediato
    aplicarDescuentoEnTarjetas();

    // Reintentar varias veces por si las tarjetas cargan tarde
    setTimeout(aplicarDescuentoEnTarjetas, 800);
    setTimeout(aplicarDescuentoEnTarjetas, 2000);
    setTimeout(aplicarDescuentoEnTarjetas, 4000);

    // Observar por si la colección carga más productos (lazy load / infinite scroll)
    var grid = document.querySelector('main') || document.body;
    var timer = null;
    var obs = new MutationObserver(function () {
      if (timer) clearTimeout(timer);
      timer = setTimeout(aplicarDescuentoEnTarjetas, 500);
    });
    obs.observe(grid, { childList: true, subtree: true });
  }

  /* ── INIT ── */

  function insertarContenidoPackBienvenida() {
    // Solo insertar si no existe ya
    if (document.getElementById('pimun-pack-content')) return;
    // Detectar contenedor adecuado (ajusta el selector según tu tema)
    var info = document.querySelector('h1');
    if (!info) return;
    var contentDiv = document.createElement('div');
    contentDiv.id = 'pimun-pack-content';
    contentDiv.textContent = 'Incluye Enterito/Pijama + Gabucha + Manta swaddle';
    // Estilo: fuente igual al ejemplo, más pequeño, gris legible, responsivo
    contentDiv.style = [
      'font-family: "Montserrat", "Arial", sans-serif',
      'font-size: 0.92rem',
      'font-weight: 400',
      'color: #7a7a7a',
      'margin-bottom: 7px',
      'letter-spacing: 0.01em',
      'line-height: 1.1',
      'white-space: nowrap',
      'overflow: hidden',
      'text-overflow: ellipsis',
      'max-width: 100%',
      'display: block'
    ].join(';') + ';';
    // Mobile: aún más pequeño y margen ajustado
    var styleTag = document.createElement('style');
    styleTag.textContent =
      '@media (max-width: 749px) {' +
      '  #pimun-pack-content {' +
      '    font-size: 0.78rem !important;' +
      '    margin-bottom: 5px !important;' +
      '  }' +
      '}';
    document.head.appendChild(styleTag);
    // Insertar justo antes del título
    info.parentNode.insertBefore(contentDiv, info);
  }

  function init() {
    if (_initDone) {
      escucharVariantes();
      return;
    }

    // Página de colección packs (verificar ANTES que producto)
    if (esColeccionPacks()) {
      _initDone = true;
      initColeccion();
      return;
    }

    // Página de producto pack
    if (esProductoPack()) {
      _initDone = true;
      refrescarDescuento();
      escucharVariantes();
      observarVariantes();
      // Mostrar contenido según el pack
      var config = obtenerConfigProducto();
      // Imagen mobile ahora se gestiona solo por CSS, no JS
      if (config && config.keywords.includes('bienvenida')) {
        insertarContenidoPackBienvenida();
      } else if (config && (
        config.keywords.includes('primeros-dias') ||
        config.keywords.includes('primeros dias') ||
        config.keywords.includes('primeros días') ||
        config.keywords.includes('primeros')
      )) {
        insertarContenidoPackPrimerosDias();
      } else if (config && (
        config.keywords.includes('sueno') ||
        config.keywords.includes('sueño') ||
        config.keywords.includes('set-sueno') ||
        config.keywords.includes('set-sueño')
      )) {
        insertarContenidoPackSueno();
      } else if (config && (
        config.keywords.includes('paseo') ||
        config.keywords.includes('set-paseo')
      )) {
        insertarContenidoPackPaseo();
      }
      return;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  setTimeout(init, 1500);

})();